// extracted by mini-css-extract-plugin
export var label = "_ff-2";
export var slideContainer = "_ff-0";
export var slider = "_ff-1";